module.exports = __webpack_public_path__ + "static/media/election.cde81a12.png";